import InvoiceRow from "./InvoiceRow";

export default function InvoiceTable({
  invoices,
  loading,
  onAnular,
  onVerInvalidacion,
  onDescargarInvalidacion, // 🆕 NUEVO
  isDownloadingInvalidacion, // 🆕 NUEVO
  onClearFilters,
  hasFilters,
  onReprint // 🆕
}) {
  if (loading) {
    return (
      <div className="text-center mt-4">
        <div className="spinner"></div>
        <p className="mt-2">Cargando facturas...</p>
      </div>
    );
  }

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>CODIGO DE GENERACION</th>
            <th>CLIENTE</th>
            <th>FECHA</th>
            <th>ESTADO</th>
            <th>PDF</th>
            <th>JSON</th>
            <th>ANULAR</th>
            <th>REIMPRIMIR</th> {/* 🆕 */}
          </tr>
        </thead>

        <tbody>
          {invoices.length === 0 ? (
            <tr>
              <td colSpan={8} className="text-center"> {/* 🆕 de 7 a 8 */}
                <div className="no-data">
                  <p>📭 No hay facturas para mostrar</p>
                  {hasFilters && (
                    <button 
                      className="btn btn-secondary btn-sm" 
                      onClick={onClearFilters}
                    >
                      Limpiar filtros
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ) : (
            invoices.map((invoice) => (
              <InvoiceRow
                key={invoice.id}
                invoice={invoice}
                onAnular={onAnular}
                onVerInvalidacion={onVerInvalidacion}
                onDescargarInvalidacion={onDescargarInvalidacion} // 🆕 NUEVO
                isDownloadingInvalidacion={isDownloadingInvalidacion} // 🆕 NUEVO
                onReprint={onReprint} // 🆕
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}